// What the upload badge says (row #40, 2026-10-19). Pure: tested in
// tests/outboxCore.test.ts. The badge itself is uploadBadge.ts.

export interface UploadCounts {
  waiting: number;
  scanFrames: number;
  rejected: number;
  sending: boolean;
  lastError: string | null;
  lastErrorAt: number | null;
  lastSentAt: number | null;
  backgroundSync: boolean;
}

export interface BadgeText {
  show: boolean;
  headline: string; // "17 waiting to upload"
  detail: string; // the last error, or what happens next
  tone: "ok" | "warn" | "bad";
}

function ago(ms: number): string {
  const s = Math.max(0, Math.round(ms / 1000));
  if (s < 60) return `${s} s ago`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 48) return `${h} h ago`;
  return `${Math.round(h / 24)} days ago`;
}

export function badgeText(c: UploadCounts, now: number): BadgeText {
  if (!c.waiting && !c.rejected) return { show: false, headline: "", detail: "", tone: "ok" };
  const parts: string[] = [];
  if (c.waiting) {
    const frames = c.scanFrames && c.scanFrames === c.waiting ? ` scan frame${c.scanFrames === 1 ? "" : "s"}` : "";
    parts.push(`${c.waiting}${frames} waiting to upload`);
  }
  if (c.rejected) parts.push(`${c.rejected} need${c.rejected === 1 ? "s" : ""} attention`);
  const headline = parts.join(" · ");
  let detail: string;
  let tone: BadgeText["tone"] = c.rejected ? "bad" : "ok";
  if (c.sending) detail = "Sending…";
  else if (c.lastError) {
    detail = `${c.lastError}${c.lastErrorAt !== null ? ` (${ago(now - c.lastErrorAt)})` : ""}`;
    tone = c.rejected ? "bad" : "warn";
  } else if (c.waiting) detail = c.backgroundSync ? "Uploads continue when there is signal, even with the app closed." : "Keep WRAP open until this reaches 0: uploads stop while the app is closed.";
  else detail = "Refused by the server: open the list to retry or discard.";
  if (c.waiting && !c.sending && c.lastSentAt !== null) detail += ` Last sent ${ago(now - c.lastSentAt)}.`;
  return { show: true, headline, detail, tone };
}
